const SocketConfig = {
  CREDENTIALS_COOKIE: 'mc-socket-credentials',
  ADDRESS_COOKIE: 'mc-socket-address',
  RECONNECT_PERIOD: 3000,
  KEEPALIVE: 30,
  RESUBSCRIBE: true,
};

export default SocketConfig;
